import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { notification } from "antd";
import { updatePhoto } from "../api/employees";

export const employeeSlice = createSlice({
  name: "employee",
  initialState: {
    employeeList: [],
  },
  reducers: {
    setEmployeeList: (state, action) => {
      state.employeeList = action.payload;
    },

    deleteEmployee: (state, action) => {
      state.employeeList = state.employeeList.filter(
        (x) => x.id !== action.payload
      );
    },

    updateEmployee: (state, action) => {
      const { id, title, category } = action.payload;
      let employee = state.employeeList.find((x) => x.id === id);
      Object.assign(employee, action.payload);
    },
  },
});

export const {
  setEmployeeList,
  deleteEmployee,
  toggleEmployee,
  updateEmployee,
} = employeeSlice.actions;

export const selectEmployees = (state) => state.employee.employeeList;

export default employeeSlice.reducer;

export const getEmployeeList =
  (
    startDate,
    endDate,
    searchKeyword,
    pageNumber,
    pageSize,
    isBodMember,
    showOnHomePage,
    callback
  ) =>
  (dispatch) => {
    axios
      .get("employee/getList", {
        params: {
          startDate,
          endDate,
          searchKeyword,
          pageNumber,
          pageSize,
          isBodMember,
          showOnHomePage,
        },
      })
      .then(({ data }) => {
        dispatch(setEmployeeList(data.employees));
        callback && callback(data.totalCount);
      })
      .catch((error) => {
        notification.error({ message: error.response.data.message });
        callback && callback();
      });
  };

export const deleteEmployeeById = (id, callback) => (dispatch) => {
  axios
    .delete(`employee/${id}`)
    .then(({ data }) => {
      notification.success({ message: data.message });
      dispatch(deleteEmployee(id));
      callback && callback();
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const toggleEmployeeById = (id, callback) => (dispatch) => {
  axios
    .patch(`employee/togglePublish/${id}`)
    .then(({ data }) => {
      notification.success({ message: data.message });
      dispatch(toggleEmployee(id));
      callback && callback();
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const createEmployee = (formData, callback) => (dispatch) => {
  axios
    .post("employee/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => {
      notification.success({ message: data.message });
      callback && callback();
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const updateEmployeeById =
  (id, employeeData, callback) => (dispatch) => {
    axios
      .put(`employee/${id}`, employeeData)
      .then(({ data }) => {
        notification.success({ message: data.message });
        dispatch(updateEmployee(employeeData));
        callback && callback();
      })
      .catch((error) => {
        notification.error({ message: error.response.data.message });
        callback && callback();
      });
  };

export const updateEmployeePhoto =
  (employeeId, formData, callback) => (dispatch) => {
    updatePhoto(employeeId, formData)
      .then(({ data }) => {
        notification.success({ message: "Successfully updated photo" });
        callback && callback();
      })
      .catch((error) => {
        notification.error({ message: error.response.data.message });
        callback && callback();
      });
  };
